import React from 'react';
import PropTypes from 'prop-types';

import { EZLOGIC_TITLE_DELETE_WARNING } from '../../../../../constants/language_tokens';
import { useTranslate } from '../../../../../features/languages';
import DeleteConfirmDialog from '../../../EzloAccount/components/DeleteConfirmDialog';

const DeviceGroupDelete = ({ name, onDeleteDeviceGroup }) => {
    const { t } = useTranslate();

    return (
        <DeleteConfirmDialog
            dialogText={`${t(EZLOGIC_TITLE_DELETE_WARNING)} ${name}?`}
            confirmFn={onDeleteDeviceGroup}
        />
    );
};

export default DeviceGroupDelete;

DeviceGroupDelete.propTypes = {
    name: PropTypes.string,
    onDeleteDeviceGroup: PropTypes.func,
};
